import { select, call, takeLatest, put } from 'redux-saga/effects';
import { Toaster, Intent, Position } from '@blueprintjs/core';

import * as $ui from 'modules/ui';
import { UI } from 'modules/ui';
import * as $auth from 'modules/auth';
import * as api from '../api';
import * as actions from '../actions';

const DatasetsToaster = Toaster.create({
  position: Position.BOTTOM_RIGHT,
});

const createDataset = function* ({ payload }) {
  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);

  const { key, ...datasetData } = payload;

  try {
    yield put($ui.setTrue(UI.Datasets.IsCreating)());

    yield call(api.createDataset, token, key, publisherId, datasetData);

    yield put($ui.setFalse(UI.Datasets.CreateDialogVisible)());

    yield* refetchDatasets();
  } catch (error) {
    DatasetsToaster.show({
      icon: 'warning-sign',
      intent: Intent.DANGER,
      message: 'Something went wrong while creating a dataset',
    });
  } finally {
    yield put($ui.setFalse(UI.Datasets.IsCreating)());
  }

  function* refetchDatasets() {
    const queryParams = new URLSearchParams(window.location.search);
    const pageSize = queryParams.get('pageSize') || 20;
    const pageNumber = 1;

    yield put(actions.fetchDatasets(pageSize, pageNumber));
  }
};

export const createDatasetSaga = function* () {
  yield takeLatest(actions.createDataset, createDataset);
};
